var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow",
    d: "M24 12C24 11.1716 23.3284 10.5 22.5 10.5H10.5734C8.79162 10.5 7.89928 8.34572 9.15921 7.08579L13.065 3.18001C13.6526 2.59243 13.6509 1.63926 13.0612 1.05376C12.4745 0.471185 11.5271 0.472858 10.9425 1.05751L1.41421 10.5858C0.633165 11.3668 0.633165 12.6332 1.41421 13.4142L10.942 22.942C11.5263 23.5263 12.4737 23.5263 13.058 22.942C13.6419 22.3581 13.6423 21.4115 13.0589 20.827L9.15184 16.913C7.89365 15.6525 8.78637 13.5 10.5673 13.5H22.5C23.3284 13.5 24 12.8284 24 12Z",
    fill: "#000A18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.cd1191de76713ad33c3135f1746668c4.svg";
export { ForwardRef as ReactComponent };